var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"join-us",attrs:{"id":"join","data-area":_vm.fr + '_show',"data-serverid":"16318","data-exts":JSON.stringify({
    fr: _vm.fr,
}),"data-extswan":{
    fr: _vm.fr,
}},nativeOn:{"click":function($event){return _vm.joinUs.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }